import angular from 'angular';
import { RealEstateSearchResultListWithLoanComponent } from './real-estate-search-result-list-with-loan.component';
import favouriteService from './../../favourites/service/favourites-service.module';

const MODULE_NAME = 'realEstateSearchResultListWithLoan';

export default angular.module(MODULE_NAME, [favouriteService]).component('realEstateSearchResultListWithLoan', RealEstateSearchResultListWithLoanComponent).name;


